import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  /**
   * キオスク端末アカウントのトークン取得が IP アドレス制限で拒否された状態なら true。
   * true の間はグローバルの IP 制限エラー画面（全画面オーバーレイ）が表示される。
   *
   * persist しない（メモリのみ）。リロードされても初回セッション確立時の
   * fetchSession で再検知されるため、永続化は不要。
   */
  isIpRestricted: boolean
}
type Actions = {
  /** トークン取得が IP アドレス制限で拒否されたときにコールされる */
  ipRestrictionDetected: () => void
  /** トークン取得に成功（= IP 制限を通過）したときにコールされる */
  ipRestrictionResolved: () => void
}

export const useIpRestrictionStore = create<State & Actions>()(
  devtools(
    immer(set => ({
      isIpRestricted: false,
      ipRestrictionDetected: () =>
        set(state => {
          state.isIpRestricted = true
        }),
      ipRestrictionResolved: () =>
        set(state => {
          state.isIpRestricted = false
        }),
    })),
  ),
)

export const selectIsIpRestricted = (state: State) => state.isIpRestricted
